module.exports = __webpack_public_path__ + "img/AdobeStock_145826644.d06b7a1.png";